<p class="label-form">{{label}}</p>
<div class="spacer"></div>
<textarea [rows]="8" [(ngModel)]="value" (ngModelChange)="valueChanged()"></textarea>
